import Text from 'components/Text/Text';
import React, { useContext, useRef } from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { IUsersContext, UsersContext } from '../../../usersState/usersContext';
import { IGetRoles } from 'types';
import breadcrumbs from 'images/breadcrumbs.svg';
import { useFetchData } from 'hooks/useFetchData';
import { getRoles } from 'backend/additionalInformation';
import SelectDropdownReloader from 'components/SelectDropdownReloader/SelectDropdownReloader';
import style from './RoleSelect.module.scss';

const { Option } = Select;

const RoleSelect: React.FC = () => {
	const { IDSelectedRole, setIDRole } = useContext<IUsersContext>(UsersContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading, refetch, responseError } = useFetchData<IGetRoles, null>(getRoles);
	const { t } = useTranslation('listing');

	const value = !loading ? IDSelectedRole : undefined;

	return (
		<div className={style.container} data-test="RoleSelect">
			<Text translationNameSpace="listing" translationKey="roleLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setIDRole}
				value={value}
				loading={loading}
				listItemHeight={response?.data.roles.length}
				notFoundContent={responseError ? <SelectDropdownReloader onReload={refetch} /> : undefined}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placeholder={t('selectPlaceholder')}>
				{response?.data.roles.length ? (
					<>
						<Option value={null}>
							<svg className={style.icon}>
								<use xlinkHref={`${breadcrumbs}#userRoleAll`} />
							</svg>
							<Text translationNameSpace="listing" translationKey="allRolesLabel" asFragment={true} />
						</Option>
						{response.data.roles.map((el) => (
							<Option className={style.listItem} value={el.id} key={el.id}>
								<svg className={style.icon}>
									<use xlinkHref={`${breadcrumbs}#userRole${el.name}`} />
								</svg>
								<Text translationNameSpace="listing" translationKey={el.name} asFragment={true} />
							</Option>
						))}
					</>
				) : null}
			</Select>
		</div>
	);
};

export default RoleSelect;
